/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * KitMembers are joins between kit and user within a space. They contain role & permission
 * information.
 */
import _merge from "lodash/merge";
import _remove from "lodash/remove";

import { KitMember } from "@thenounproject/lingo-core";

import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";

import { updateSpaceMember } from "@redux/actions/spaceMembers/useUpdateSpaceMember";

export default createEntityReducer<KitMember>(
  "kitMembers",
  () => {},

  objectBuilder => {
    objectBuilder
      .addCase(updateSpaceMember.fulfilled, (state, action) => {
        const kitMembers = action.payload?.entities?.kitMembers;
        if (kitMembers) {
          _merge(state, kitMembers);
        }
        // And another hack to keep space member roles in sync with kit member objects.
        // Perhaps we could normalize the spaceMember on kitMember, so this wouldn't be an issue
        // Again, the issue is that the share kit modal expects kitMembers to have the space role as well
        // which the API only returns for useKitMembers endpoint.
        const spaceMembers = action.payload?.entities?.spaceMembers ?? {};
        Object.values(spaceMembers).forEach(spaceMember => {
          Object.values(state).forEach(kitMember => {
            if (
              kitMember.userId === spaceMember.userId &&
              kitMember.spaceId === spaceMember.spaceId
            ) {
              (kitMember as KitMember & { spaceRole: string }).spaceRole = spaceMember.role;
            }
          });
        });
      })
      .addDefaultCase((state, action: any) => {
        const kitMembers = getEntitiesFromAction<KitMember>(action, "kitMembers");
        return mergeEntitiesIfChanged(state, kitMembers);
      });
  }
);
